import { Utils } from "utils";
import { Hotels } from "services";
import { ThunkType } from "store/types";
import { NIGHT_BREAKTIME_IN_MINUTES } from "constants/constants";

import { setRouteResponse } from "./slice";

export const getHotelsThunk =
  (dayIndex: number): ThunkType<Promise<void>> =>
  async (dispatch, getStore) => {
    try {
      const request = getStore().routeRequest.data!;
      const route = getStore().routeResponse.data!;
      const days = route!.days;
      const currentDay = days[dayIndex];

      const nightItem = currentDay.selectedPlaces.find(
        (item) => item?.breaktime === NIGHT_BREAKTIME_IN_MINUTES
      );

      let cityName = "";
      let countryName = "";

      switch (true) {
        case Boolean(nightItem): {
          cityName = nightItem!.address_info.city ?? nightItem!.title;
          countryName = Utils.Helpers.getCountryName(
            nightItem!.address_info.country_code
          );

          break;
        }

        case request.buildVariant === "linear": {
          cityName = request.finish!.name;
          countryName = request.finish!.country;

          break;
        }

        case request.buildVariant === "radius": {
          if (request.startAsFinish) {
            cityName = request.start!.name;
            countryName = request.start!.country;
          } else {
            const lastPlace = currentDay.selectedPlaces.at(-1);
            if (lastPlace) {
              cityName = lastPlace.address_info.city ?? lastPlace.title;
              countryName = Utils.Helpers.getCountryName(
                lastPlace!.address_info.country_code
              );
            }
          }

          break;
        }
      }

      if (!cityName || !countryName) {
        return Promise.reject(
          new Error("Couldn't select last place in this route")
        );
      }

      const hotels = new Hotels(countryName, cityName);
      await hotels.search();
      const list = hotels.list;

      dispatch(
        setRouteResponse({
          ...route,
          days: route.days.map((item, index) =>
            index === dayIndex ? { ...item, hotels: list } : item
          ),
        })
      );

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  };
